import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getTuinaReservationSlots } from '@/service/tuina'

export const fetchTuinaReservationSlots = createAsyncThunk(
  'tuinaReservationSlots/fetchTuinaReservationSlots',
  async ({ query = {} } = {}, { rejectWithValue }) => {
    try {
      const response = await getTuinaReservationSlots(query)
      return {
        data: response.data,
        query
      }
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.msg ||
          error?.response?.data?.message ||
          error?.msg ||
          error?.message ||
          '加载可约时间失败'
      )
    }
  }
)

const reservationSlotsSlice = createSlice({
  name: 'tuinaReservationSlots',
  initialState: {
    fetching: false,
    error: null,
    query: {},
    data: []
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTuinaReservationSlots.pending, (state) => {
        state.fetching = true
        state.error = null
        state.data = []
      })
      .addCase(fetchTuinaReservationSlots.fulfilled, (state, action) => {
        state.fetching = false
        state.error = null
        state.query = action.payload.query
        state.data = action.payload.data || []
      })
      .addCase(fetchTuinaReservationSlots.rejected, (state, action) => {
        state.fetching = false
        state.error = action.payload ?? action.error?.message ?? null
      })
  }
})

export default reservationSlotsSlice.reducer
